<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="40%"
    @close="close"
  >
    <el-form :model="formData" :rules="rules" label-width="120px" ref="form">
      <slot name="tip"></slot>
      <el-row :gutter="20">
        <el-col :span="16">
          <template v-if="isEmail">
            <el-form-item :label="this.$t('company.email')">
              <el-input v-model="formData.email" :disabled="true"></el-input>
            </el-form-item>
          </template>
          <template v-else>
            <el-form-item :label="this.$t('company.phone')">
              <el-input v-model="formData.phone" :disabled="true"></el-input>
            </el-form-item>
          </template>
        </el-col>
        <el-col :span="6" v-if="isChange">
          <el-button
            type="primary"
            @click="changeWay(isEmail)"
            :disabled="!isChange"
            >{{ $t('developer.changeWay') }}</el-button
          >
        </el-col>
        <el-col :span="16">
          <el-form-item :label="$t('developer.code')" prop="code">
            <el-input v-model="formData.code"> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <timing
            ref="timing"
            @toGetCode="getEmailCode"
            :status="true"
            :isShow="true"
          >
          </timing>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="submitForm">{{
        $t('common.confirm')
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import timing from '@/components/timing'
import { verifyCode } from '@/services/acountApi.js'
import { getEmailCode, sendPhoneCode } from '@/services/userCenter.js'
export default {
  components: {
    timing
  },
  props: {
    // 接口传参的type
    checkType: String,
    // 手机| 邮箱
    isEmail: {
      type: Boolean,
      default: false
    },
    isChange: {
      type: Boolean,
      default: false
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    title: String,
    formData: {
      type: Object
    },
    sourceOrgin: {
      type: Object
    }
  },
  watch: {
    formData: {
      handler(val) {},
      immediate: true,
      deep: true
    }
  },
  data() {
    let checkCode = (rules, value, cb) => {
      if (value) {
        let params = {
          type: this.checkType,
          code: value
        }
        params.loginName = this.isEmail
          ? this.sourceOrgin.email
          : this.sourceOrgin.phone
        verifyCode(params)
          .then(data => {
            if (data.code === '00000000') {
              return cb()
            } else {
              return cb(new Error(data.message))
            }
          })
          .catch(e => {})
      }
    }
    return {
      rules: {
        code: this.validatorInputEmptyRule(true, 6, checkCode)
      }
    }
  },
  methods: {
    close() {
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
      if (this.$refs.timing) {
        this.$refs.timing.clearTimer()
      }
      this.$emit('onclose')
    },
    changeWay(val) {
      this.isEmail = !val
      this.$refs.timing.clearTimer()
    },
    getEmailCode() {
      let params = {
        type: this.checkType
      }
      if (this.isEmail) {
        params.email = this.sourceOrgin.email
        getEmailCode(params)
          .then(data => {
            if (data.code === '00000000') {
              this.$refs.timing.beginTime()
            } else {
              this.errorMessage(data.message)
            }
          })
          .catch(e => {})
      } else {
        params.phone = this.sourceOrgin.phone
        sendPhoneCode(params)
          .then(data => {
            if (data.code === '00000000') {
              this.$refs.timing.beginTime()
            } else {
              this.errorMessage(data.message)
            }
          })
          .catch(e => console.log(e))
      }
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.isEmail) {
            let params = {
              loginName: this.sourceOrgin.email,
              code: this.formData.code
            }
            this.$emit('submit', params)
          } else {
            let params = {
              loginName: this.sourceOrgin.phone,
              code: this.formData.code
            }
            this.$emit('submit', params)
          }
        }
      })
    }
  },
  mounted() {}
}
</script>

<style scoped lang="less"></style>



// WEBPACK FOOTER //
// src/components/verify.vue